import React from 'react';
import { StyleSheet } from 'react-native';
import Modal from 'utils/packages/Modal';
import SelectDepositToInvestmentAccountMethodModalContent from './SelectDepositToInvestmentAccountMethodModalContent';
import { isWeb } from '../../../constants';
const strings = {
    title: 'Where would you like your money\xa0to\xa0go?',
};
const SelectDepositToInvestmentAccountMethodModal = {
    show: (amount, tradingAccount, depositMethod) => {
        Modal.show(<SelectDepositToInvestmentAccountMethodModalContent amount={amount} depositMethod={depositMethod} tradingAccount={tradingAccount}/>, {
            containerStyle: styles.modal,
            title: strings.title,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
        // On web, inset the options so their hover highlight sits inside the modal
        ...(isWeb && { paddingHorizontal: 8, paddingBottom: 8 }),
    },
});
export default SelectDepositToInvestmentAccountMethodModal;
